import type { OutlookSpaceAsset, TimeStreamAssets } from 'owa-timestream-types';
import markAllAssetsAsDeleted from './markAllAssetsAsDeleted';
import upsertAssets from './upsertAssets';

export default function updateAssets(
    assets: TimeStreamAssets,
    outlookSpaceAssets: OutlookSpaceAsset[]
) {
    markAllAssetsAsDeleted(assets);
    upsertAssets(assets, outlookSpaceAssets, true);
}
